import React, { useEffect, useState } from "react";
import InvoiceTable from "./InvoiceTable";
import { plusIcon } from "../../../Base/SVG";
import ChartOuter from "./Chart/ChartOuter";
import InvoiceModal from "./InvoiceModal";
import { AnimatePresence, motion } from "framer-motion";
import CreateModal from "./CreateModal";

export default function Invoice() {
  const [modal, setModal] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const lazyDummy = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    if (modal) document.body.classList.add("active");
    else document.body.classList.remove("active");
  }, [modal]);
  useEffect(() => {
    lazyDummy();
  }, []);
  return (
    <>
      <div className="invoice">
        <div className="auto__container">
          {isLoading ? (
            <>
              <h3 className="placeholder"></h3>
              <div className="invoice__head">
                <div className="chart placeholder"></div>
                <div className="chart placeholder"></div>
              </div>
              <h3 className="placeholder"></h3>
              <div className="invoiceTable__header">
                <div className="search placeholder"></div>
                <div className="invoiceTable__header-action">
                  <button type="button" className="button placeholder"></button>
                  <button type="button" className="button placeholder"></button>
                </div>
              </div>
              <div className="invoiceTable box">
                <div className="invoiceTable__body">
                  <div className="placeholder"></div>
                  {[0, 1, 2, 3].map((item, index) => {
                    return <div className="placeholder" key={index}></div>;
                  })}
                </div>
              </div>
            </>
          ) : (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
              exit={{ opacity: 0, y: 10 }}
            >
              <h3>Dashboard</h3>

              <div className="invoice__head">
                <div className="invoice__head-item">
                  <div className="invoice__head-content">
                    <h4 className="big">Create new payment request</h4>
                    <p>
                      Create a new payment request with and receive the payment
                      in cryptocurrency directly to your wallet. Say goodbye to
                      complicated payment processes and start accepting payments
                      with just a few clicks.
                    </p>
                    <div
                      className="button white"
                      onClick={() => setModal("create")}
                    >
                      {plusIcon} Create Request
                    </div>
                  </div>
                  <div className="invoice__head-image">
                    <img
                      src={process.env.PUBLIC_URL + "/images/coinBug.png"}
                      alt="coinBug"
                    />
                  </div>
                </div>
                <ChartOuter />
              </div>
              <div className="invoice__inner">
                <h3>Invoice History</h3>
                <InvoiceTable setModalData={setModalData} setModal={setModal} />
              </div>
            </motion.div>
          )}
        </div>
      </div>
      <AnimatePresence>
        {modal === "details" && (
          <InvoiceModal
            close={() => {
              setModal(null);
              setModalData(null);
            }}
            title={
              <>
                <span className="purple"></span> Receipt
              </>
            }
            {...modalData}
          />
        )}
        {modal === "create" && (
          <CreateModal
            close={() => setModal(null)}
            title={
              <>
                <span className="purple"></span> New payment request
              </>
            }
          />
        )}
      </AnimatePresence>
    </>
  );
}
